import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark, faChevronDown } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    const handleClick = () => {
        setIsNavOpen(!isNavOpen);
    };

    const closeNav = () => {
        setIsNavOpen(false);
    };

    useEffect(() => {
        const handleScroll = () => {
            // Hero section is 100vh, so we check if scrolled past 90% of viewport
            const heroHeight = window.innerHeight * 0.9;
            setIsScrolled(window.scrollY > heroHeight);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className="header">
            <button
                className={`toggle-nav ${isNavOpen ? 'active' : ''} ${isScrolled ? 'dark' : ''}`}
                onClick={handleClick}
                aria-label="Toggle navigation"
            >
                <FontAwesomeIcon icon={isNavOpen ? faXmark : faBars} />
            </button>
            <nav className={`navigation-menu ${isNavOpen ? 'open' : ''}`}>
                <a href="#" className="navigation-menu__brand" onClick={closeNav}>
                    FAB<span>.</span>
                </a>

                <a href="#about" className="navigation-menu__link" onClick={closeNav}>
                    About
                </a>

                <a href="#projects" className="navigation-menu__link" onClick={closeNav}>
                    Projects
                </a>

                <a
                    href="https://felipebazza.github.io/indecision-app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="navigation-menu__link"
                    onClick={closeNav}
                >
                    Training Projects
                </a>

                <div className="navigation-menu__cta">
                    <a href="#contact" className="btn btn--primary" onClick={closeNav}>
                        Contact Me
                    </a>
                </div>
            </nav>
        </header>
    );
};

export default Header;